export var AssetOriginEnum;
(function (AssetOriginEnum) {
    AssetOriginEnum["FIAT"] = "FIAT";
    AssetOriginEnum["CRYPTO"] = "CRYPTO";
})(AssetOriginEnum || (AssetOriginEnum = {}));
//# sourceMappingURL=asset-origin.enum.js.map